import { render, staticRenderFns } from "./KpiWidget.vue?vue&type=template&id=a081f6ba"
import script from "./KpiWidget.vue?vue&type=script&lang=js"
export * from "./KpiWidget.vue?vue&type=script&lang=js"
import style0 from "./KpiWidget.vue?vue&type=style&index=0&id=a081f6ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports